import React from 'react'
import { useParams } from 'react-router-dom'
import ErrorView from '../../components/ErrorView'
import LoadingScreen from '../../components/LoadingScreen'
import ShowQuoteView from './ShowQuoteView'
import { useQuoteViewData } from '../hooks/useQuoteViewData'

const ShowQuoteApp = () => {
  const { id } = useParams()
  const { loading, error, quote } = useQuoteViewData(id)

  if (loading) return <LoadingScreen text="Cargando..." />
  if (error) return <ErrorView error={error} />

  return <ShowQuoteView quote={quote} />
}

export default ShowQuoteApp
